module.exports = __webpack_public_path__ + "static/img/intro_icon5.8fde5789.png";